const doc = [({"no":({"js":({"routes":({"admin":({"surveys":({"index":({"add_new_survey":"Legg til nytt spørreskjema"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;